/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_SUBSCRIPTION_BILLING_REPORT, GET_SUBSCRIPTION_BILLING_REPORT } from 'src/actions/subscriptionBillingReportActions';

const initialState = {
  report: null,
  isFetching: false,
  message: ''
};

const subscriptionBillingReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SUBSCRIPTION_BILLING_REPORT: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_SUBSCRIPTION_BILLING_REPORT: {
      const { report, message } = action.payload;

      return produce(state, (draft) => {
        draft.report = report;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default subscriptionBillingReportReducer;
